import React from "react";
import { Share } from "@capacitor/share";

export default function ShareButton() {
  const websiteUrl = "https://todaysminicrossword.com";

  const handleShare = async () => {
    const shareData = {
      title: "Daily Mini Crossword",
      text: "Try today's mini crossword!",
      url: websiteUrl,
    };

    try {
      // Capacitor native share
      const { value: canShare } = await Share.canShare();

      if (canShare) {
        await Share.share(shareData);

        window.gtag?.("event", "share_clicked", {
          share_method: "native",
        });

        return;
      }

      // Browser fallback
      if (navigator.share) {
        await navigator.share(shareData);

        window.gtag?.("event", "share_clicked", {
          share_method: "native",
        });

        return;
      }

      // Desktop fallback
      await navigator.clipboard.writeText(websiteUrl);

      window.gtag?.("event", "share_clicked", {
        share_method: "clipboard",
      });

      alert("Website link copied!");
    } catch (error) {
      // User cancelled the native share dialog.
      if (error?.name !== "AbortError") {
        console.error("Share failed:", error);
      }
    }
  };

  return (
    <button
      style={{
        margin: "1em auto",
        padding: "1rem",
        backgroundColor: "yellow",
        fontSize: "1rem",
        borderRadius: "1rem",
        fontWeight: "900",
        marginLeft: ".8em",
        marginRight: "1rem",
        border: "1px solid gold",
      }}
      type="button"
      onClick={handleShare}
    >
      🔗 Share
    </button>
  );
}

